<template>
    <div class="fst-SearchList">
        <el-radio-group size="mini" v-model="classificationFilter" @change="$emit('classificationFilter-update', classificationFilter)">
            <el-radio-button label="good">Хорошие</el-radio-button>
            <el-radio-button label="all">Все</el-radio-button>
            <el-radio-button label="bad">Плохие</el-radio-button>
        </el-radio-group>
        <SearchList :value="documentList" :showExportMenu="false" :noLikeThis="true" :params="{hideUserTags: true}"
                    :active="true">
            <template v-slot:belowDescription="slot">
                <el-alert v-if="slot.item.bad" :closable="false" :type="slot.item.bad ? 'warning' : 'success'">
                    <template v-if="slot.item.reason">{{ slot.item.reason }}</template>
                    <template v-else>Документ помечен как неподходящий</template>
                </el-alert>
            </template>
        </SearchList>
    </div>
</template>
<script>
import SearchList from "@/components/search/SearchList.vue";

export default {
    name: 'QueryAnalysisDocList',
    components: {SearchList},
    props: {
        value: {
            type: Object,
            default: () => ({})
        },
        valueFn: {
            type: Function, default: null
        }
    },
    computed: {
        documentList: function () {
            if (this.valueFn) {
                return this.valueFn(this.classificationFilter);
            } else {
                return this.value;
            }
        },
    },
    data: function () {
        return {
            classificationFilter: "all"
        }
    },
}
</script>

<style scoped lang="scss">

</style>